@if (account(); as account) {
  @let name = account.name ?? '';
  @let phone = account.phoneNumber | bringozPhone;
  <bz-tooltip data-sl="mask" [content]="phone ? name + ', ' + phone : name">
    <app-bringoz-state-link appBringozIdGenerator="shipperAccountLink"
                            class="text-ellipsis"
                            permission="accounts.demand.get"
                            state="accounts-detail-demand.active-deliveries"
                            [params]="params()"
                            [text]="account.name">
    </app-bringoz-state-link>
  </bz-tooltip>
}
